import { DatepickerRange, RangeDatepickerComponent } from '@ui/aos-lib';
import { DateUtil } from '@portal/shared/utils/date-util';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { FilterModel } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { MissingProgrammingRecordsFieldName } from '../missing-programming-records.types';

export const MISSING_PROGRAMMING_RECORDS_DATE_TIME: FilterModel = {
  items: [],
  selected: [],
  width: 0,
  filterType: MissingProgrammingRecordsFieldName.DateTimeUTC,
  title: TranslateRegistry.get.FILTER.TITLE.INITIAL_TRANSMISSION_TIME,
  isDatepicker: true,
  minDate: null,
  maxRangeDays: 365,
  dateRange: () => [
    DateUtil.toISOString((RangeDatepickerComponent.LAST_MONTH.getValue() as DatepickerRange).start),
    DateUtil.toISOString((RangeDatepickerComponent.LAST_MONTH.getValue() as DatepickerRange).end)
  ],
  defaultDateRange: () => [
    DateUtil.toISOString((RangeDatepickerComponent.LAST_MONTH.getValue() as DatepickerRange).start),
    DateUtil.toISOString((RangeDatepickerComponent.LAST_MONTH.getValue() as DatepickerRange).end)
  ]
};
